import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import Collapse from "@mui/material/Collapse"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"
import { useSelector } from "react-redux"
import { Link as RouterLink } from "react-router-dom"

import Row from "../../../common/components/Row"
import { canAccessOwnerAccountSettings } from "../../users/accountRole"
import { selectProfile } from "../../users/reducer"
import { selectCRMSettings } from "../reducer"
import { SETTINGS_TABS, createSettingsTabURL } from "../settings"

export default function BrokerInfoTooltip() {
  const crmSettings = useSelector(selectCRMSettings)
  const profile = useSelector(selectProfile)
  if (!canAccessOwnerAccountSettings(profile)) {
    return null
  }
  return (
    <Collapse
      in={
        !crmSettings.settings.loading &&
        !(
          crmSettings.settings.broker_title &&
          crmSettings.settings.brokerage_name
        )
      }
    >
      <Row sx={{ alignItems: "center", gap: 0.5 }}>
        <InfoOutlinedIcon
          sx={{ fill: (theme) => theme.palette.primary.main }}
        />
        <Typography variant="h6" sx={{ color: "primary.main" }}>
          Tip
        </Typography>
        <Typography variant="body1">
          Update your broker info in{" "}
          <Link
            component={RouterLink}
            to={createSettingsTabURL(SETTINGS_TABS.crmSettings)}
          >
            crm settings
          </Link>{" "}
          to have them prefilled here!
        </Typography>
      </Row>
    </Collapse>
  )
}
